import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-link',
  templateUrl: './link.component.html',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent {
  href = input<string>();
  target = input<string>();
  linkClass = input<string>('link');
  labelKey = input<string>();
  iconClass = input<string>();
}
